import './about.css';
import AboutCommunity from './community';
import AboutGallery from './gallery';
import { Fibonacci } from './fibonacci';
import { useRef } from 'react';

export const AboutButton = ({show, toggle}) => (
  <button
    className={`about-button ${show ? 'top' : 'home'}`}
    onClick={show ? () => window.location.reload() : toggle}
  >
    {show ? '^^^ Return ^^^' : 'vvv Learn More vvv'}
  </button>
);

export const AboutPage = ({show}) => {
  return (
    <div className={`about-container ${show ? 'active' : ''}`}>
      <Fibonacci/>
      <section className='about-section'>
        <div className='about-content'>
          <h1 className='about-title'>
            Meet the Founder
          </h1>

          <p className='about-description'>
            Learn about the vision behind Phi Corp and our latest features.
          </p>
        </div>

        <video
          className='about-video'
          controls
          muted
          autoPlay
          loop
          playsInline
          preload='metadata'
        >
          <source
            src='/about/Meet the Founder.mp4'
            type='video/mp4'
          />
        </video>
      </section>

      <section className='about-section reverse'>
        <div className='about-content'>
          <h1 className='about-title'>
            The Pitch
          </h1>

          <p className='about-description'>
            Discover the ideas behind Vitruvian and how we are reshaping interactions with digital avatars.
          </p>
        </div>

        <video
          className='about-video'
          controls
          muted
          autoPlay
          loop
          playsInline
          preload='metadata'
        >
          <source
            src='/about/Vitruvian Pitch.mp4'
            type='video/mp4'
          />
        </video>
      </section>

      <section className='about-section'>
        <div className='about-content'>
          <h1 className='about-title'>
            Gallery
          </h1>
          <p className='about-description'>
            Check out some of the highlights at Phi Corp.
          </p>
        </div>
        <AboutGallery/>
      </section>

      <section className='about-section'>
        <div className='about-content'>
          <p className='about-description'>
            Explore the Phi Corp Community:
          </p>
        </div>
        <AboutCommunity/>
      </section>
      <section className='about-section'>
        <a
          className='about-title'
          href="/pitchdeck"
          rel="noopener noreferrer"
          target="_blank"
        >
          - Pitchdeck -
        </a>
      </section>
      <p className='about-epilogue'>
        Phi Corp is a Fibonacci reasearch company focused on creating 3D avatar pipelines, assets and experiences. <br/>
        The Vitruvian is designed to create downloadable avatars based on image input. <br/>
        Mirror-Cast relies on The Vitruvian ID to experience the next generation of web interactions. <br/><br/>
        Contact: phicorpco@gmail.com
      </p>
    </div>
  );
};
